// GA4 page-view tracker for React Router. Fires a `page_view` event to
// gtag on every pathname change so SPA navigations show up in Google
// Analytics (not just the initial load). Also exports a small `track`
// helper for explicit event reporting (lead submitted, CTA clicked, etc).
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const GA_ID = process.env.REACT_APP_GA4_MEASUREMENT_ID || "G-0H01BGYP1K";

export function track(eventName, params = {}) {
  if (typeof window === "undefined" || typeof window.gtag !== "function") return;
  try {
    window.gtag("event", eventName, params);
  } catch (_e) { /* swallow — analytics must never break the app */ }
}

export default function Analytics() {
  const { pathname, search } = useLocation();

  useEffect(() => {
    if (typeof window === "undefined" || typeof window.gtag !== "function") return;
    const page_path = pathname + (search || "");
    const page_location = window.location.origin + page_path;
    try {
      window.gtag("event", "page_view", {
        page_path,
        page_location,
        page_title: document.title,
        send_to: GA_ID,
      });
    } catch (_e) { /* swallow */ }
  }, [pathname, search]);

  return null;
}
